import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DragDropContext, Draggable, Droppable, } from '@hello-pangea/dnd';
import clsx from 'clsx';
import { useState } from 'react';
// https://flowbite.com/docs/components/tables/
export function Table({ className, children, fixed }) {
    return (_jsx("div", { className: clsx('flex flex-col', className), children: _jsx("div", { className: "overflow-x-auto sm:-mx-2 lg:-mx-4", children: _jsx("div", { className: "inline-block min-w-full py-2 sm:px-2 lg:px-4", children: _jsx("div", { className: "overflow-hidden shadow-md sm:rounded-lg", children: _jsx("table", { className: clsx('min-w-full', { 'table-fixed': fixed }), children: children }) }) }) }) }));
}
Table.Head = function TableHead({ className, children, }) {
    return (_jsx("thead", { className: clsx('bg-gray-50 dark:bg-gray-700', className), children: children }));
};
Table.HeadRow = function TableHeadRow({ className, children, }) {
    return _jsx("tr", { className: className, children: children });
};
Table.HeadCell = function TableHeadCell({ className, children, }) {
    return (_jsx("th", { scope: "col", className: clsx('px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-700 dark:text-gray-400', className), children: children }));
};
Table.Body = function TableBody({ className, children, }) {
    return _jsx("tbody", { className: clsx('', className), children: children });
};
Table.ReorderableBody = function ReorderableTableBody({ droppableId, onReorder, className, children, }) {
    const [canDrop, setCanDrop] = useState(true);
    const handleDragEnd = (result) => {
        if (result.source.droppableId !== result.destination?.droppableId) {
            return;
        }
        onReorder(result.draggableId, result.source.index, result.destination.index)
            .catch(() => {
            // No-op since we can't log it from component library
        })
            .finally(() => {
            setCanDrop(true);
        });
    };
    return (_jsx(DragDropContext, { onDragEnd: handleDragEnd, children: _jsx(Droppable, { droppableId: droppableId, isDropDisabled: !canDrop, children: (provided) => (_jsxs("tbody", { className: className, ref: provided.innerRef, ...provided.droppableProps, children: [children, provided.placeholder] })) }) }));
};
Table.Row = function TableRow({ className, children, }) {
    return (_jsx("tr", { className: clsx('border-b bg-white dark:border-gray-700 dark:bg-gray-800', className), children: children }));
};
Table.ReorderableRow = function ReorderableRow({ id, index, className, children, }) {
    return (_jsx(Draggable, { draggableId: id, index: index, children: (provided) => (_jsx("tr", { className: clsx('border-b bg-white dark:border-gray-700 dark:bg-gray-800', className), ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps, children: children })) }, id));
};
Table.Cell = function TableCell({ className, children, }) {
    return (_jsx("td", { className: clsx('whitespace-nowrap px-6 py-4 text-sm text-gray-500 dark:text-gray-400', className), children: children }));
};
